module.exports = __webpack_public_path__ + "static/media/space_active.91267f19.png";